import React, { useContext } from "react";
import Menu from "./Menu";
import { MarketContext } from "../context/MarketContext";

const TopBar = () => {
  const { ticks, wsConnected } = useContext(MarketContext);

  const nifty = ticks["NIFTY"] || { price: 24263.50, percentChange: "+0.05%", isDown: false };
  const sensex = ticks["SENSEX"] || { price: 77682.94, percentChange: "+0.04%", isDown: false };

  const niftyChange = nifty.isDown ? "-13.30" : "+13.30";
  const sensexChange = sensex.isDown ? "-28.34" : "+28.34";

  return (
    <div className="topbar-container" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 24px", height: "50px", borderBottom: "1px solid #eee", backgroundColor: "#ffffff" }}>
      
      {/* Left Indices Ticker matching Zerodha Kite */}
      <div className="indices-container" style={{ display: "flex", gap: "24px", alignItems: "center", fontSize: "12px", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
        
        {/* NIFTY 50 */}
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <span style={{ fontWeight: 600, color: "#666" }}>NIFTY 50</span>
          <span style={{ fontWeight: 600, color: nifty.isDown ? "#f23645" : "#089981" }}>
            {nifty.price?.toFixed(2)}
          </span>
          <span style={{ fontSize: "11px", color: "#888" }}>
            {niftyChange} ({nifty.percentChange})
          </span>
        </div>

        {/* SENSEX */}
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <span style={{ fontWeight: 600, color: "#666" }}>SENSEX</span>
          <span style={{ fontWeight: 600, color: sensex.isDown ? "#f23645" : "#089981" }}>
            {sensex.price?.toFixed(2)}
          </span>
          <span style={{ fontSize: "11px", color: "#888" }}>
            {sensexChange} ({sensex.percentChange})
          </span>
        </div>

        {/* WS Status Dot */}
        <span title={wsConnected ? "WebSocket Live Feed Active" : "HTTP Polling Fallback"} style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: wsConnected ? "#089981" : "#f57f17", display: "inline-block" }} />
      </div>

      {/* Right Header Navigation & Actions */}
      <Menu />
    </div>
  );
};

export default TopBar;
